<app-responsive-topbar></app-responsive-topbar>
<div class="bg-container centered">
    <router-outlet></router-outlet>
</div>
